/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manage_Producers_DescriptionInputs */

const en_manage_producers_description = /** @type {(inputs: Manage_Producers_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add, edit, or remove coffee producers.`)
};

const es_manage_producers_description = /** @type {(inputs: Manage_Producers_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agrega, edita o elimina productores de cafe.`)
};

/**
* | output |
* | --- |
* | "Add, edit, or remove coffee producers." |
*
* @param {Manage_Producers_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const manage_producers_description = /** @type {((inputs?: Manage_Producers_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manage_Producers_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_manage_producers_description(inputs)
	return es_manage_producers_description(inputs)
});